import React from 'react';

import { CrossCircleIcon } from '@vlabs/icons';
import { ButtonWithPermissions } from '@vlabs/monokit/shared/ui/button-with-permissions';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export function DetachCell({
  onClick,
  buttonProps,
  permissions,
  row,
}) {
  const { t } = useTranslation();

  return (
    <ButtonWithPermissions
      data-testid="detachCell"
      icon={<CrossCircleIcon />}
      kind="primary"
      onClick={() => onClick(row.original)}
      permissions={permissions}
      round
      title={t('faces:buttons.detach')}
      variant="dimmed"
      {...(buttonProps || {})}
    />
  );
}

DetachCell.propTypes = ({
  row: PropTypes.objectOf(PropTypes.any),
  onClick: PropTypes.func,
  buttonProps: PropTypes.object,
  permissions: PropTypes.shape({
    rules: PropTypes.arrayOf(PropTypes.string).isRequired,
    method: PropTypes.oneOf(['oneof', 'allof']),
  }),
});

DetachCell.defaultProps = ({
  row: undefined,
  onClick: undefined,
  buttonProps: undefined,
  permissions: {},
});
